import { isProjectArchived } from "./projectVisibility";

/**
 * Aggregate scoped time logs into project hour totals (snapshot fields).
 */
export function aggregateProjectHoursFromLogs(logs = []) {
  const projTotals = {};

  logs.forEach((log) => {
    const name = log.project_name || "Unknown Project";
    const key = log.project_id || name;

    if (!projTotals[key]) {
      projTotals[key] = {
        project_id: log.project_id || null,
        name,
        hrs: 0,
      };
    }

    projTotals[key].hrs += Number(log.total_hours || 0);

    if (log.project_id && !projTotals[key].project_id) {
      projTotals[key].project_id = log.project_id;
    }

    if (log.project_name) {
      projTotals[key].name = log.project_name;
    }
  });

  return Object.values(projTotals)
    .map((entry) => ({
      project_id: entry.project_id,
      name: entry.name,
      hrs: parseFloat(entry.hrs.toFixed(3)),
    }))
    .sort((a, b) => b.hrs - a.hrs);
}

/**
 * Join dashboard aggregates to org-scoped project rows resolved by project_id.
 * Returns only rows that resolve to a live project (and active, when restricted).
 */
export function reconcileProjectHoursRows(
  aggregates = [],
  projects = [],
  { restrictToActiveProjects = false } = {},
) {
  const projectsById = new Map(
    (projects || []).map((project) => [project.project_id, project]),
  );

  return aggregates.flatMap((entry) => {
    if (!entry.project_id) {
      return [];
    }

    const project = projectsById.get(entry.project_id);

    if (!project) {
      return [];
    }

    if (restrictToActiveProjects && isProjectArchived(project)) {
      return [];
    }

    return [
      {
        ...entry,
        project_id: project.project_id,
        name: project.project_name || entry.name,
        created_by: project.created_by,
        clickable: true,
      },
    ];
  });
}
